import { styled } from '@mui/material';
import { DataGrid } from "@mui/x-data-grid";

// .MuiDataGrid-columnHeaders {
//   // display: table-header-group;
//   border-top: 1px solid rgb(240, 240, 240);
//   border-bottom: 2px solid rgb(240, 240, 240);
//   background-color: #fff;
//   outline:none;
  
//   .MuiDataGrid-columnHeadersInner{ background-color: #fff; }
//   .MuiDataGrid-columnHeader { padding: 0; background-color: transparent;outline:none; }
//   // .MuiDataGrid-columnHeader:not(:last-child) .MuiDataGrid-columnHeaderDraggableContainer:after {
//   //   position: absolute;
//   //   content: "";
//   //   background-color: rgb(240, 240, 240);
//   //   width: 1px;
//   //   height: 28px;
//   //   right: 0px;
//   //   top: 10px;
//   // }
//   .MuiDataGrid-iconButtonContainer { width: 20px; }
//   .MuiDataGrid-columnSeparator { display:none; }

//   // .MuiDataGrid-columnHeaderTitleContainerContent {
//   //   flex: auto;
//   // }
//   height:50px !important;
// }

export const StyledDataGrid = styled(DataGrid)`

// border: 1px solid #e9ecf1;
margin-top: 10px;
height:95% !important;
  
  .MuiDataGrid-columnHeaders {
    border-top: 1px solid #e9ecf1;
    border-bottom: 0.1px solid #9da7b7;
    background-color: #e9ecf1;
    outline:none;
    min-height:45px !important;
    max-height:45px !important;
    line-height:45px !important;
    border-top-right-radius:12px;
    border-top-left-radius:12px;
    .MuiDataGrid-columnHeadersInner{ background-color: #e9ecf1; }
    .MuiDataGrid-columnHeader { padding: 0; background-color: transparent;outline:none; }
    .MuiDataGrid-iconButtonContainer { width: 20px;}
    .MuiDataGrid-columnHeader:not(:last-child) .MuiDataGrid-columnHeaderDraggableContainer:after {
          position: absolute;
          content: "";
          background-color: #9da7b7;
          width: 0.1px;
          height: 45px;
          right: -2.5px;
          top: 1px;
        }
    .MuiDataGrid-columnSeparator { display: none; }
  }

  // .MuiFormControl-root {
  //   border: 3px solid #e9ecf1;
  //   border-radius:12px;
  //   outline:none;
  // }
  
  .MuiBox-root{
    margin-bottom: 10px;
  }

  .MuiDataGrid-virtualScroller {
    background-color: #fff;
    margin-top: 45px !important;
    border-bottom-right-radius:12px !important;
    border-bottom-left-radius:12px !important;
    border: 3px solid #e9ecf1;
    border-top: none;
    overflow-x:hidden;
    
    // .MuiDataGrid-row { max-height: fit-content !important; }
    .MuiDataGrid-row .MuiDataGrid-cell {
      display: flex;
      background-color: #fff;
      outline:none;
      line-height: 1.3;
      border-bottom: 2px solid #e9ecf1;
      border-color: #9da7b7;
      border-width: 0.1px;
      font-size: 0.875rem;
      justify-content: flex-start;
      align-items: center;
      padding: 8px 10px;
      padding-left: 15px;
      overflow: hidden;
      min-height: 52px !important;
      max-height: 52px !important;
      .MuiLink-root .MuiGrid-container {
        align-items: center;
        .MuiAvatar-root {
          width: 32px;
          height: 32px;
        }
      }
      .MuiCheckbox-root {
        padding-left: 0px;
        margin-left: -5.9px;
        margin-top: 0px;
      }
      .MuiIconButton-root {
        margin-top: 0px;
        margin-bottom: 0px;
      }
      // Cell data font size
      // .css-7f8t4x-MuiTypography-root {
      //   font-size: 0.775rem;
      // }


      .flex-end {
        display: flex;
        justify-content: flex-end !important;
        margin-right: 31px !important;
      }
    }
  }
  
  .MuiDataGrid-footerContainer {
    border: none;
  }

  .Mui-checked {
    color: rgb(24, 144, 255) !important;
  }

  .MuiDataGrid-columnHeaderTitle {
    line-height: 1.5rem;
    text-align: left;
    color: #545454;
    padding: 12px;
    padding-left:15px;
    font-size: 0.9rem;
    font-weight: 600;
    text-transform: capitalize ;
  }

  .MuiDataGrid-menuIcon {
    display: none;
  }

  .MuiDataGrid-columnHeader--sorted {
    .MuiDataGrid-sortIcon{
      color: rgb(140, 140, 140);
    }
  }

  .MuiDataGrid-columnSeparator {
    color: rgb(240, 240, 240);
  }

  .MuiToolbar-root{
    border: 3px solid #e9ecf1;
    border-radius:12px;
    box-shadow:none !important;
  }

  .MuiDataGrid-selectedRowCount {
    color:#488dff;
    background-color:#fff;
    border:1px solid #488dff;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 7px;
    font-weight: bold;
    font-size: 13px;
    height: 40px;
    margin-left: 1px;
    margin-top:-10px;
  }

  // .MuiTablePagination-root {
  //   font-weight: bold;
  //   font-size: 13px;
  // }

  .MuiTablePagination-selectLabel {
    // font-weight: 600;
    font-size: 13px;
  }

  .MuiInputBase-root  {
    // font-weight: 600;
    font-size: 13px;
  }

  .MuiTablePagination-displayedRows {
    // font-weight: 600;
    font-size: 13px;
  }

  .MuiLink-root {
    text-align: left;
    color: rgb(38, 38, 38);
    margin: 0px;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 1.57;
    
  }
`;